<template>
    <svg :width="width" :height="height" class="icon" aria-hidden="true" focusable="false">
        <use :xlink:href="`${spriteUrl}#app-${props.svg}`"></use>
    </svg>
</template>

<script setup>
import { defineProps, computed } from "vue";

const props = defineProps({
    svg: {
        type: String,
        required: true,
    },
    width: {
        type: Number,
        default: 24,
    },
    height: {
        type: Number,
        default: 24,
    }
});

const spriteUrl = computed(() => new URL("/img/app-icons.svg", import.meta.url).href);
</script>

